import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { userApi } from "@/lib/userApi";
import { Trophy, Heart, Gift } from "lucide-react";
import { Avatar } from "@/components/community/ChatList";

const MEDALS = ["text-amber-300", "text-slate-300", "text-amber-700/90", "text-white/40", "text-white/40"];

/** Ranking del mes: quién recibe más likes y quién trae más amigos. */
export const RankingCard = () => {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("likes");

  useEffect(() => {
    userApi.get("/social/ranking").then(({ data }) => setData(data)).catch(() => setData(false));
  }, []);

  if (!data || data === false) return null;
  const rows = tab === "likes" ? data.likes : data.friends;
  if (!data.likes.length && !data.friends.length) return null;

  return (
    <div className="glass-card forge-card p-5" data-testid="ranking-card">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-white font-semibold">
          <Trophy className="w-4 h-4 text-amber-300" /> Ranking del mes
        </div>
        <div className="flex gap-1.5">
          {[["likes", "Más likes"], ["friends", "Más amigos"]].map(([k, label]) => (
            <button key={k} data-testid={`ranking-tab-${k}`} onClick={() => setTab(k)}
              className={`glass-btn ${tab === k ? "glass-btn-red" : ""} px-3 py-1 rounded-xl text-[11px]`}>
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-4 space-y-2">
        {rows.length === 0 && (
          <p className="text-xs text-white/45">Aún nadie en esta lista este mes.</p>
        )}
        {rows.map((r, i) => (
          <Link key={r.key} to={`/perfil/${r.key}`} data-testid={`ranking-row-${i}`}
            className="flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-white/[0.04] transition-colors">
            <span className={`font-heading font-bold text-sm w-5 shrink-0 ${MEDALS[i]}`}>{i + 1}</span>
            <Avatar person={r.user} size={34} />
            <span className="flex-1 min-w-0">
              <span className="block text-sm text-white truncate flex items-center gap-1.5">
                {r.user?.name}
                {i === 0 && tab === "likes" && (
                  <span title="Embajador del mes" data-testid="ranking-ambassador-badge"
                    className="text-[9px] px-1.5 py-0.5 rounded-full border border-amber-300/50 text-amber-200 flex items-center gap-1 shrink-0">
                    <img src="/logo-digital-forge.jpg" alt="" className="w-2.5 h-2.5 rounded-full" />
                    EMBAJADOR
                  </span>
                )}
              </span>
              <span className="block text-[11px] text-white/45">
                {tab === "likes" ? `${r.posts} ${r.posts === 1 ? "publicación" : "publicaciones"}` : "este mes"}
              </span>
            </span>
            <span className="text-xs text-amber-300 font-mono flex items-center gap-1 shrink-0">
              {tab === "likes"
                ? <><Heart className="w-3.5 h-3.5" /> {r.likes}</>
                : <><Gift className="w-3.5 h-3.5" /> {r.friends}</>}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RankingCard;
